import {useNewProduct} from "../../../store/contexts/NewProductContext";
import {TYPES} from "../../../store/reducers/NewProductReducer";
import {useEffect, useState} from "react";
import axios from "axios";
import "../../../assets/css/pages/product.css";

const InventoryCard = () => {
    const { product,  dispatch, errors, data } = useNewProduct();

    const handleAddressChange = (event, index) => {

        dispatch({
            type: TYPES.SET_PRODUCT,
            payload: {...product,
                addresses: product.addresses.map((address, numbering) => {
                    return numbering === index ? { shop_address_id: parseInt(event.target.value), quantity: address.quantity } : address
                })}
        })
    }

    const handleQuantityChange = (event, index) => {
        dispatch({
            type: TYPES.SET_PRODUCT,
            payload: {
                ...product,
                addresses: product.addresses.map((address, numbering) => {
                    return numbering === index ? { shop_address_id: address.shop_address_id, quantity: parseInt(event.target.value) } : address
                })
            }
        })
    }

    const handleMoreAddress = () => {
        if(product.addresses.length < data?.shopAddresses.length){
            dispatch({
                type: TYPES.SET_PRODUCT,
                payload: {
                    ...product,
                    addresses: [...product.addresses, {
                        shop_address_id: data?.shopAddresses.map((address, index) => {
                            return product.addresses.some(item => item.shop_address_id !== address.id) && address.id
                        }).find(newItem => newItem !== false),
                        quantity: 1
                    }]
                }
            })
        }
    }

    const handleAddressFieldRemoval = (event, index) => {
        dispatch({
            type: TYPES.SET_PRODUCT,
            payload: {
                ...product,
                addresses: product.addresses.filter((item, numbering) => numbering !== parseInt(index))
            }
        })
    }

    return (
        <div className="card card-flush py-4">
            <div className="card-header">
                <div className="card-title">
                    <h2>Inventory</h2>
                </div>
            </div>

            <div className="card-body pt-0">
                <div className="mb-10 fv-row">
                    <label className="required form-label">SKU</label>

                    <input type="text" name="sku" className="form-control mb-2"
                           placeholder="SKU Number" value={product.sku}
                           onChange={event => dispatch({
                               type: TYPES.SET_PRODUCT,
                               payload: {...product, sku: event.target.value }
                           })}
                    />
                    {
                        errors.hasOwnProperty("sku") && (
                            <div className="fs-7 mb-7 text-danger">{errors.sku}</div>
                        )
                    }
                    <div className="text-muted fs-7">Enter the product SKU.</div>
                </div>

                <div className="mb-10 fv-row">
                    <label className="form-label">ID Number</label>

                    <input type="text" name="product_id" className="form-control mb-2"
                           placeholder="ID Number" value={product.item_id}
                           onChange={event => dispatch({
                               type: TYPES.SET_PRODUCT,
                               payload: {...product, item_id: event.target.value}
                           })}
                    />
                    {
                        errors.hasOwnProperty("item_id") && (
                            <div className="fs-7 mb-7 text-danger">{errors.item_id}</div>
                        )
                    }
                    <div className="text-muted fs-7">Enter the ID Number. Not Unique identifier!</div>
                </div>

                <div className="mb-10 fv-row">
                    {
                        product.addresses.map((address, index) => (
                            <>
                                <div key={index} className="d-flex gap-3">
                                    <div className="w-50">
                                        <label className="required form-label">Address</label>
                                        <select className="form-select mb-2" data-control="select2" data-hide-search="true"
                                                data-placeholder="Select an option" id="kt_ecommerce_add_product_status_select"
                                                onChange={(event) => handleAddressChange(event, index)}
                                                value={address.shop_address_id || ''}
                                        >
                                            <option>Choose Seller Address</option>
                                            {
                                                data?.shopAddresses?.map((shopAddress, index) => (
                                                    <option key={index} value={shopAddress.id}>
                                                        {shopAddress.address}
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="w-50">
                                        <label className="required form-label">Product Quantity</label>
                                        <input type="number" name="shelf" className="form-control mb-2"
                                               placeholder="Choose Product Quantity" value={address.quantity} onChange={event => handleQuantityChange(event, index)}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        onClick={event => handleAddressFieldRemoval(event, index)}
                                        className="btn btn-danger btn-hover-scale btn-size"
                                    >
                                        -
                                    </button>
                                </div>
                                {
                                    errors.hasOwnProperty(`addresses.${index}.shop_address_id`) && (
                                        errors[`addresses.${index}.shop_address_id`].map((item, index) => (
                                            <div key={index} className="fs-7 mb-7 text-danger">{item}</div>
                                        ))
                                    )
                                }
                                {
                                  errors.hasOwnProperty(`addresses.${index}.quantity`) && (
                                    errors[`addresses.${index}.quantity`].map((item, index) => (
                                      <div key={index} className="fs-7 mb-7 text-danger">{item}</div>
                                    ))
                                  )
                                }
                            </>
                        ))
                    }

                    <button type="button" data-repeater-create=""
                            className="btn btn-sm btn-light-primary"
                            onClick={handleMoreAddress}
                    >
                            <span className="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="24" height="24" viewBox="0 0 24 24"
                                     fill="none">
                                    <rect opacity="0.5" x="11" y="18" width="12"
                                          height="2" rx="1"
                                          transform="rotate(-90 11 18)"
                                          fill="black"/>
                                    <rect x="6" y="11" width="12" height="2"
                                          rx="1" fill="black"/>
                                </svg>
                            </span>
                        Add another Address
                    </button>
                    {
                      errors.hasOwnProperty(`addresses`) && (
                        <div className="fs-7 mb-7 mt-2 text-danger">{errors['addresses']}</div>
                      )
                    }
                    <div className="text-muted fs-7 mt-3">Select seller in General tab in order to see relevant addresses</div>
                    <div className="text-muted fs-7 mt-3">Enter the product address and quantity</div>
                </div>
            </div>
        </div>
    )
}

export default InventoryCard;